import { useState, useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { getOpenAIClient } from "@/lib/openai";
import { toast } from "sonner";
import type { ExistingFile } from "../types";

export const useVectorStoreFiles = (vectorStoreId: string | null | undefined) => {
  const [existingFiles, setExistingFiles] = useState<ExistingFile[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchExistingFiles = async () => {
      if (!vectorStoreId) return;
      setIsLoading(true);

      try {
        console.log('Fetching files for vector store:', vectorStoreId);
        
        // Get files from our database
        const { data: dbFiles, error: dbError } = await supabase
          .from('vector_store_files')
          .select('*')
          .eq('vector_store_id', vectorStoreId);

        if (dbError) throw dbError;
        console.log('Database files:', dbFiles);
        
        setExistingFiles(dbFiles);
      } catch (error) {
        console.error('Error fetching files:', error);
        toast.error("Failed to load existing files");
      } finally {
        setIsLoading(false);
      }
    };

    fetchExistingFiles();
  }, [vectorStoreId]);

  return { existingFiles, setExistingFiles, isLoading };
};